module.exports = __webpack_public_path__ + "img/hr-wooden-particle-22.2d6ddb4e.png";